import { initThreeScene } from './three-scene.js';
import { initChatbot } from './chatbot.js';

document.addEventListener('DOMContentLoaded',()=>{
const cart=[];
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];

const cartBtn=$('#cartBtn');
const cartCount=$('#cartCount');
const overlay=$('#cartOverlay');
const cartClose=$('#cartClose');
const cartBody=$('#cartBody');
const cartTotal=$('#cartTotal');
const cartSubtotal=$('#cartSubtotal');
const checkoutBtn=$('#checkoutBtn');
const cartEmpty=$('#cartEmpty');
const cartBottom=$('#cartBottom');
const cartProductDetail=$('#cartProductDetail');
const cartItemsSection=$('#cartItemsSection');
const cartItemsList=$('#cartItemsList');
const cartPromo=$('#cartPromo');
const cartPromoBtn=$('#cartPromoBtn');
const cartDiscountRow=$('#cartDiscountRow');
const cartDiscount=$('#cartDiscount');
const toast=$('#toast');
const checkoutOverlay=$('#checkoutOverlay');
const checkoutClose=$('#checkoutClose');
const checkoutBody=$('#checkoutBody');
const checkoutItems=$('#checkoutItems');
const checkoutSubtotal=$('#checkoutSubtotal');
const checkoutDiscountRow=$('#checkoutDiscountRow');
const checkoutDiscount=$('#checkoutDiscount');
const checkoutTotal=$('#checkoutTotal');
const checkoutEmail=$('#checkoutEmail');
const checkoutPayBtn=$('#checkoutPayBtn');
const mobileBtn=$('#mobileBtn');
const navLinks=$('#navLinks');
const navbar=$('#navbar');
const infographicWarp=$('#infographicWarp');
const floofcoreIconWrap=$('#floofcoreIconWrap');
const threeCanvas=$('#threeCanvas');
const chatContainer=$('#chatContainer');

let threeScene=null;
if(threeCanvas){
  threeScene=initThreeScene(threeCanvas);
  window.addEventListener('beforeunload',()=>{if(threeScene)threeScene.dispose()});
}
if(chatContainer)initChatbot(chatContainer);

let t;
function show(m,type='info'){
  const icons={info:'✦',success:'✓',error:'✕'};
  const icon=icons[type]||icons.info;
  clearTimeout(t);
  toast.className='toast';
  toast.innerHTML=`<div class="toast-inner"><span class="toast-icon">${icon}</span><span class="toast-msg">${m}</span></div><div class="toast-bar"></div>`;
  toast.classList.add('show',type);
  requestAnimationFrame(()=>{const bar=toast.querySelector('.toast-bar');if(bar)bar.style.width='0%'});
  t=setTimeout(()=>{toast.classList.remove('show',type);const bar=toast.querySelector('.toast-bar');if(bar)bar.style.width='100%'},2500);
}

let promoApplied=false;
let discountAmount=0;
const taxRate=0.05;
function calcTax(amt){return amt*taxRate}
function update(){
  const totalItems=cart.reduce((s,i)=>s+i.qty,0);
  cartCount.textContent=totalItems;
  if(!cart.length){
    cartBody.innerHTML='<div class="cart-empty" id="cartEmpty"><div class="cart-empty-icon">✦</div><p class="cart-empty-title">Your orbit is empty</p><p class="cart-empty-desc">Add some products to get started</p><a href="#floofcore" class="btn btn-primary cart-empty-btn" onclick="document.getElementById(\'cartOverlay\').classList.remove(\'open\')">Browse Products</a></div>';
    cartBottom.style.display='none';
    return;
  }
  cartBottom.style.display='';
  cartBody.innerHTML=`
    <div class="cart-product-detail">
      <div class="cart-product-header">
        <img src="/floofcore-icon.png" alt="Floofcore" class="cart-product-img">
        <div class="cart-product-info">
          <h3 class="cart-product-name">Floofcore Bot License</h3>
          <div class="cart-product-meta">
            <span class="cart-product-price">$1.99 USD</span>
          </div>
        </div>
      </div>
      <div class="cart-product-about">
        <p class="cart-section-title">About the product</p>
        <p class="cart-section-desc">This product is for the <strong>Floofcore Bot License</strong>. The license grants you access to <strong>3 Discord server instances</strong> with all premium features.</p>
        <p class="cart-section-desc">To receive your license key, join our <a href="#" class="cart-link">support server</a> and open a ticket. A team member will deliver your key.</p>
        <p class="cart-section-desc">Each license covers up to 3 Discord servers. Need more? Purchase additional licenses.</p>
      </div>
      <div class="cart-product-features">
        <p class="cart-section-title">What you'll get</p>
        <ul class="cart-section-list">
          <li>Floofcore Bot License for 3 bot instances — 1 bot in up to 3 guilds, or 3 bots in 1 guild</li>
          <li>All premium modules: Cross-server, Moderation, Economy, Music & more</li>
          <li>Priority support via Discord</li>
          <li>Access to Module Hub and all future updates</li>
        </ul>
      </div>
      <div class="cart-product-risks">
        <p class="cart-section-title">Are there any risks?</p>
        <p class="cart-section-desc">This is a unilateral agreement — we handle things directly with our providers to make sure everything's copacetic :)</p>
        <p class="cart-section-desc">If your payment method gets disputed, we'll revoke the license and you'll be blacklisted from future purchases.</p>
      </div>
      <div class="cart-items-section">
        <p class="cart-section-title">Your items</p>
        ${cart.map((item,i)=>`
          <div class="cart-item">
            <img src="${item.img||'/floofcore-icon.png'}" alt="" class="cart-item-img">
            <div class="cart-item-info">
              <div class="cart-item-name">${item.name}</div>
              <div class="cart-item-meta">${item.recurring?'Recurring ('+item.recurring+')':'One-time'}</div>
            </div>
            <div class="cart-item-right">
              <div class="cart-qty">
                <button class="qty-minus" data-index="${i}">−</button>
                <span>${item.qty}</span>
                <button class="qty-plus" data-index="${i}">+</button>
              </div>
              <span class="cart-item-price">$${(item.price*item.qty).toFixed(2)}</span>
              <button class="cart-item-remove" data-index="${i}" aria-label="Remove">✕</button>
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
  $$('.qty-minus').forEach(b=>b.addEventListener('click',()=>{
    const idx=parseInt(b.dataset.index);
    if(cart[idx].qty>1){cart[idx].qty--}else{cart.splice(idx,1)}
    update();
  }));
  $$('.qty-plus').forEach(b=>b.addEventListener('click',()=>{
    cart[parseInt(b.dataset.index)].qty++;update();
  }));
  $$('.cart-item-remove').forEach(b=>b.addEventListener('click',()=>{
    cart.splice(parseInt(b.dataset.index),1);update();show('Removed from cart');
  }));
  const subtotal=cart.reduce((s,i)=>s+i.price*i.qty,0);
  if(cartSubtotal)cartSubtotal.textContent=`$${subtotal.toFixed(2)}`;
  if(promoApplied&&subtotal>=5){
    discountAmount=subtotal*0.1;
    cartDiscountRow.style.display='';
    cartDiscount.textContent=`-$${discountAmount.toFixed(2)}`;
  }else{
    discountAmount=0;
    cartDiscountRow.style.display='none';
  }
  const afterDisc=subtotal-discountAmount;
  const tax=calcTax(afterDisc);
  const taxRow=document.getElementById('cartTaxRow');
  const taxSpan=document.getElementById('cartTax');
  if(tax>0){
    if(taxRow){taxRow.style.display=''}
    if(taxSpan)taxSpan.textContent=`$${tax.toFixed(2)}`;
  }else{
    if(taxRow){taxRow.style.display='none'}
  }
  cartTotal.textContent=`$${(afterDisc+tax).toFixed(2)}`;
}

function add(p){
  const e=cart.find(i=>i.product===p.product);
  if(e){e.qty++}else{cart.push({...p,qty:1})}
  update();show(p.name+' added to your orbit!');
  cartBtn.style.animation='none';
  void cartBtn.offsetHeight;
  cartBtn.style.animation='cartWiggle .5s ease';
}

checkoutPayBtn.addEventListener('click',()=>{
  const email=checkoutEmail.value.trim();
  if(!email||!email.includes('@')){show('Please enter a valid email');return}
  const payment=selectedPayment;
  if(payment!=='paypal'&&payment!=='card'&&payment!=='payhip'){show('That payment method is coming sometime!');return}
  checkoutOverlay.classList.remove('open');
  if(cart.length===1){
    const key=cart[0].payhipKey;
    if(!key||key.includes('YOUR_')||key.includes('KEY')){show('Checkout not configured — set product key');return}
    Payhip.Checkout.open({product:key,quantity:cart[0].qty,title:cart[0].name,successUrl:window.location.href});
  }else{
    const keys=cart.filter(i=>i.payhipKey&&!i.payhipKey.includes('YOUR_')).map(i=>i.payhipKey);
    if(!keys.length){show('Checkout not configured — set product keys');return}
    const cartUrl='https://payhip.com/buy?'+keys.map(k=>'cart_links[]='+k).join('&');
    window.open(cartUrl,'_blank');
  }
  show('Checkout opened — complete payment via Payhip');
});

checkoutClose.addEventListener('click',()=>checkoutOverlay.classList.remove('open'));
checkoutOverlay.addEventListener('click',e=>{if(e.target===checkoutOverlay)checkoutOverlay.classList.remove('open')});
$('#checkoutBack').addEventListener('click',()=>{
  checkoutOverlay.classList.remove('open');
  overlay.classList.add('open');
});

const paymentTrigger=$('#paymentTrigger');
const paymentDropdown=$('#paymentDropdown');
const paymentOptions=$$('.custom-select-option');
let selectedPayment='paypal';
paymentTrigger.addEventListener('click',()=>{
  paymentTrigger.classList.toggle('open');
  paymentDropdown.classList.toggle('open');
});
paymentOptions.forEach(opt=>{
  opt.addEventListener('click',function(){
    if(this.classList.contains('disabled')){show('Coming sometime!');paymentDropdown.classList.remove('open');paymentTrigger.classList.remove('open');return}
    selectedPayment=this.dataset.value;
    paymentTrigger.querySelector('.custom-select-trigger-inner').innerHTML=`<span class="payment-icon">${this.querySelector('.payment-icon').textContent}</span><span>${this.querySelector('.payment-option-name').textContent}</span>`;
    paymentOptions.forEach(o=>o.classList.remove('active'));
    this.classList.add('active');
    paymentDropdown.classList.remove('open');
    paymentTrigger.classList.remove('open');
  });
});
document.addEventListener('click',e=>{
  if(!e.target.closest('.custom-select')){paymentDropdown.classList.remove('open');paymentTrigger.classList.remove('open')}
});

cartBtn.addEventListener('click',()=>overlay.classList.add('open'));
cartClose.addEventListener('click',()=>overlay.classList.remove('open'));
overlay.addEventListener('click',e=>{if(e.target===overlay)overlay.classList.remove('open')});
checkoutBtn.addEventListener('click',()=>{
  if(!cart.length){show('Your orbit is empty');return}
  overlay.classList.remove('open');
  const subtotal=cart.reduce((s,i)=>s+i.price*i.qty,0);
  const afterDisc=subtotal-discountAmount;
  const tax=calcTax(afterDisc);
  const total=afterDisc+tax;
  let itemsHtml='';
  cart.forEach((item,i)=>{
    itemsHtml+=`
      <div class="checkout-item">
        <img src="${item.img||'/floofcore-icon.png'}" alt="" class="checkout-item-img">
        <div class="checkout-item-info">
          <div class="checkout-item-name">${item.name} × ${item.qty}</div>
          <div class="checkout-item-meta">${item.recurring?'Recurring ('+item.recurring+')':'One-time'}</div>
        </div>
        <span class="checkout-item-price">$${(item.price*item.qty).toFixed(2)}</span>
      </div>
    `;
  });
  checkoutItems.innerHTML=itemsHtml;
  checkoutSubtotal.textContent=`$${subtotal.toFixed(2)}`;
  if(promoApplied&&subtotal>=5){
    checkoutDiscountRow.style.display='';
    checkoutDiscount.textContent=`-$${discountAmount.toFixed(2)}`;
  }else{
    checkoutDiscountRow.style.display='none';
  }
  const checkoutTaxRow=document.getElementById('checkoutTaxRow');
  const checkoutTaxSpan=document.getElementById('checkoutTax');
  if(tax>0){
    if(checkoutTaxRow)checkoutTaxRow.style.display='';
    if(checkoutTaxSpan)checkoutTaxSpan.textContent=`$${tax.toFixed(2)}`;
  }else{
    if(checkoutTaxRow)checkoutTaxRow.style.display='none';
  }
  checkoutTotal.textContent=`$${total.toFixed(2)}`;
  checkoutEmail.value='';
  checkoutOverlay.classList.add('open');
});
cartPromoBtn.addEventListener('click',()=>{
  const code=cartPromo.value.trim().toUpperCase();
  if(!code){show('Enter a promo code');return}
  if(code==='MOON10'||code==='FLOOF10'){
    promoApplied=true;update();show('Promo applied — 10% off!');
  }else{
    show('Invalid promo code');
  }
});
$$('.add-to-cart').forEach(b=>b.addEventListener('click',()=>add({
  product:b.dataset.product,name:b.dataset.name,
  price:parseFloat(b.dataset.price),recurring:b.dataset.recurring||null,
  img:b.dataset.img||null,payhipKey:b.dataset.payhipKey||null
})));

mobileBtn.addEventListener('click',()=>navLinks.classList.toggle('open'));
$$('.nav-link').forEach(l=>l.addEventListener('click',()=>navLinks.classList.remove('open')));

let last=0;
window.addEventListener('scroll',()=>{
  const c=window.scrollY;
  const vh=window.innerHeight;
  last=c;

  if(infographicWarp){
    const rect=infographicWarp.getBoundingClientRect();
    if(rect.top<vh*.85){
      infographicWarp.style.transform='perspective(1200px) rotateY(.5deg) scale(1)';
    }
  }

  if(floofcoreIconWrap){
    const rect=floofcoreIconWrap.getBoundingClientRect();
    if(rect.top<vh*.8){
      floofcoreIconWrap.style.transform='perspective(600px) rotateY(-4deg) scale(1)';
    }
  }
},{passive:true});

$$('.faq-q').forEach(b=>b.addEventListener('click',()=>{
  const item=b.closest('.faq-item');
  const open=item.classList.contains('open');
  $$('.faq-item.open').forEach(e=>e.classList.remove('open'));
  if(!open)item.classList.add('open');
}));

// --- Custom Cursor ---
const dot=$('#cursorDot');
const ring=$('#cursorRing');
let cx=0,cy=0,rx=0,ry=0;
document.addEventListener('mousemove',e=>{
  cx=e.clientX;cy=e.clientY;
  dot.style.left=cx+'px';dot.style.top=cy+'px';
});
function cursorRaf(){rx+=(cx-rx)*0.15;ry+=(cy-ry)*0.15;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(cursorRaf)}
cursorRaf();
document.addEventListener('mouseleave',()=>{dot.classList.add('hide');ring.classList.add('hide')});
document.addEventListener('mouseenter',()=>{dot.classList.remove('hide');ring.classList.remove('hide')});
$$('a,button,.btn,.nav-link,.cart-btn,.faq-q,.chat-bubble,.pill-tag,.eco-badge').forEach(el=>{
  el.addEventListener('mouseenter',()=>ring.classList.add('hover'));
  el.addEventListener('mouseleave',()=>ring.classList.remove('hover'));
});

// --- Mouse-Follow Parallax ---
let mx=0,my=0;
document.addEventListener('mousemove',e=>{mx=(e.clientX/window.innerWidth-.5)*2;my=(e.clientY/window.innerHeight-.5)*2});
function parallaxRaf(){
  $$('.parallax').forEach(el=>{const d=parseFloat(el.dataset.depth||1);el.style.transform=`translate(${mx*d*8}px,${my*d*8}px)`});
  requestAnimationFrame(parallaxRaf);
}
parallaxRaf();

const obs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('animate-in');obs.unobserve(e.target)}
  });
},{threshold:.08});

$$('.feature-pill,.pricing-card,.planet-card,.faq-item,.banner-warp,.infographic-warp,.floofcore-hero,.cta-block').forEach(el=>{
  el.style.opacity='0';obs.observe(el);
});

});

